import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiNewsService } from '../../../../services/news/api/api-news.service';
import { AlertsService } from '../../../../services/alerts.service';
import { LanguagesService } from '../../../../services/languages/languages.service';
import { Language } from '../../../../models/languages/language.model';
import { NewsPredefinedTranslation } from '../../../../models/news/news-predefined-translation.model';

@Component({
  selector: 'app-news-predefined-translation-add-modal',
  templateUrl: './news-predefined-translation-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class NewsPredefinedTranslationAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  newsPredefinedId: number = 0;
  languageId: number = 0;
  title: string = '';
  summary: string = '';
  content: string = '';
  linkButtonName: string = '';
  availableLanguages: Language[] = [];

  private callbackSaved?: () => void;

  constructor(
    private apiNewsService: ApiNewsService,
    private alertsService: AlertsService,
    public languagesService: LanguagesService
  ) {}

  show(newsPredefinedId: number, existingTranslations: NewsPredefinedTranslation[], callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.newsPredefinedId = newsPredefinedId;
    this.availableLanguages = this.languagesService.languages.filter(
      l => !existingTranslations.some(t => t.languageId === l.languageId)
    );
    this.languageId = this.availableLanguages.length > 0 ? this.availableLanguages[0].languageId : 0;
    this.title = '';
    this.summary = '';
    this.content = '';
    this.linkButtonName = '';
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiNewsService.editNewsPredefinedTranslation(this.newsPredefinedId, this.languageId, this.title, this.summary, this.content, this.linkButtonName).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Translation added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding translation : ' + error);
      }
    );
  }
}
